import { userStore } from "../../../stores/user.store";
import { configStore } from "../../../stores/config.store";
import { hooksStore } from "../../../stores/hooks.store";

import { vratConfigVrstvy } from "../../../api/configVrstvy";
import { createDataTree, treeSort } from "../../../helpers/functions";

import { get as get_store } from "svelte/store";
import set from "set-value";
import get from "get-value";

export async function ziskajVrstvy() {
  const data = await vratConfigVrstvy();
  if (data) {
    const dataTree = createDataTree(data, "id", "parent_id");
    return treeSort(dataTree, "order");
  }
}

export function vratZoznamAktivnychVrstiev() {
  const zoznamAktivnychVrstiev = document.querySelectorAll(
    "#tabVrstvy input.vrstva:checked"
  );

  const vrstvy = Array.from(zoznamAktivnychVrstiev).map((vrstva) => {
    return {
      kod: vrstva.getAttribute("data-kod"),
      typ: vrstva.getAttribute("data-typ"),
      kodUrl: vrstva.getAttribute("data-kod-url"),
      isExternal: vrstva.getAttribute("data-is-external"),
      input_type: vrstva.getAttribute("data-input-type"),
    };
  });

  return vrstvy;
}

export function vratUrlAktivnychVrstiev() {
  const zoznamAktivnychVrstiev = document.querySelectorAll(
    "#tabVrstvy input.vrstva:checked"
  );

  let urls = {
    vector: "",
    raster: "",
  };

  Array.from(zoznamAktivnychVrstiev).forEach((vrstva) => {
    if (urls[vrstva.getAttribute("data-typ")] === undefined) {
      urls[vrstva.getAttribute("data-typ")] = "";
    }

    urls[vrstva.getAttribute("data-typ")] +=
      vrstva.getAttribute("data-kod-url");

    urls[vrstva.getAttribute("data-typ")] +=
      vrstva.getAttribute("type") === "radio" ? "|" : ",";
  });

  for (const type in urls) {
    if (urls[type]) {
      urls[type] = urls[type].replace(/,\s*$/, "");
    }
  }

  return urls;
}

export function nastavVrstvy() {
  const aktivneVrstvy = vratZoznamAktivnychVrstiev();
  ulozVrstvy(aktivneVrstvy);

  /* const aktivneVrstvyUrl = vratUrlAktivnychVrstiev();
  ulozUrlVrstiev(aktivneVrstvyUrl); */

  opravPrepinacVsetkychVrstiev();
  hooksStore.doAction("aktualizujVrstvyNaMape");
}

export function opravPrepinacVsetkychVrstiev() {
  const sekcie = document.querySelectorAll(
    "#tabVrstvy .sidebar__wrapper nav > section.box"
  );

  for (let sekcia of sekcie) {
    spocitajAktivne(sekcia);
  }
}

function spocitajAktivne(sekcia) {
  const vsetky = sekcia.querySelectorAll("input.vrstva").length;
  const aktivne = sekcia.querySelectorAll("input.vrstva:checked").length;
  sekcia.querySelector(".box-title small").innerHTML = `(${aktivne}/${vsetky})`;

  let s = sekcia.querySelector(".toggleAll input");
  if (s) {
    s.checked = aktivne && aktivne === vsetky ? true : false;
  }

  const sub = sekcia.querySelectorAll("section.box");
  if (sub.length) {
    for (let sekciaSub of sub) {
      spocitajAktivne(sekciaSub);
    }
  }
}

export function nastavVsetkyVrstvy(e) {
  const viditelne = e.target.checked;
  const podvrstvy = e.target
    .closest("section")
    .querySelectorAll(".box-content input");
  for (let checkbox of podvrstvy) {
    checkbox.checked = viditelne;
  }
  nastavVrstvy();
}

function ulozVrstvy(aktivneVrstvy) {
  const u = userStore.getUser();
  set(u, "options.mapa.vrstvy", aktivneVrstvy);

  userStore.updateUser(u);
}

function ulozUrlVrstiev(aktivneVrstvyUrl) {
  const u = userStore.getUser();
  set(u, "options.mapa.vrstvyUrl", aktivneVrstvyUrl);
  userStore.updateUser(u);
}

export function vratUlozeneVrstvy() {
  const u = userStore.getUser();
  let ulozeneVrstvy = get(u, "options.mapa.vrstvy", []);

  if (ulozeneVrstvy.length === 0) {
    ulozeneVrstvy = get(get_store(configStore), "pociatocne_vrstvy", []);
    ulozVrstvy(ulozeneVrstvy);
  }

  return ulozeneVrstvy;
}
